import createAdapter from './createAdapter'
const gaAdapter = createAdapter(() => !!window.ga, {
  page({ url, pathname, title }) {
    ga('set', 'page', pathname)
    ga('set', 'location', url)
    ga('set', 'title', title)
    ga('send', 'pageview')
  },
  track(eventAction, eventProperties = {}) {
    if (
      !Object.prototype.hasOwnProperty.call(eventProperties, 'eventCategory')
    ) {
      eventProperties.eventCategory = 'All'
    }
    eventProperties.eventAction = eventAction
    eventProperties.hitType = 'event'
    ga('send', eventProperties)
  },
  set(dimension, value) {
    ga('set', dimension, value)
  },
})

export { gaAdapter as ga }
